
const state = {
  Uid: null,
  user: null,
  returnUrl: null
}


const getters = {
  user (state) {
    return state.user;
  },
  isAuthenticated (state) {
    return state.Uid !== null;
  },
  returnUrl(state) {
    return state.returnUrl;
  }
}

const mutations = {
  authUser (state, userData) {
    state.Uid = userData.Uid;
    state.user = userData;
  },
  storeUser (state, user) {
    state.user = user;
  },
  clearAuthData (state) {
    state.Uid = null;
    state.user = null;
  },  
  setReturnUrl(state, url){
    state.returnUrl = url;
  },
  clearReturnUrl(state){
    state.returnUrl = null;
  }
}

const actions = {
  signup ({commit, dispatch}, authData) {
    commit('authUser', {      
      Uid: authData.Uid
    });
    
    localStorage.setItem('Uid', authData.Uid);
    localStorage.setItem('user', JSON.stringify(authData));
    dispatch('storeUser', authData);
    //dispatch('setLogoutTimer', authData.expiresIn);
  },
  login ({commit}, authData) {
    
    localStorage.setItem('Uid', authData.Uid);
    localStorage.setItem('user', JSON.stringify(authData));
    
    commit('authUser', authData);
    commit('storeUser', authData);
    //dispatch('setLogoutTimer', authData.expiresIn);
  },
  logout ({commit}) {
    commit('clearAuthData');    
    localStorage.removeItem('Uid');
    localStorage.removeItem('user');    
  },
  fetchUser ({commit}) {
    let user = localStorage.getItem('user');
    if(user)
      commit('authUser', JSON.parse(user));
  },
  fetchReturnUrl({commit}) {
    let url = localStorage.getItem('ReturnUrl');
    if (url)
      commit('setReturnUrl', url);
  },
  setReturnUrl({ commit }, url) {
    localStorage.setItem('ReturnUrl', url);
    commit('setReturnUrl', url);
  },
  clearReturnUrl({ commit}){
    localStorage.removeItem('ReturnUrl');
    commit('clearReturnUrl');
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}